import React, { useEffect, Fragment } from 'react'
import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';
//import NewRole from './NewRole';

const TABLE_HEAD = ["#", "نام", 'مقدار مکمل پول', 'مقدار باقی مانده', "از تاريخ - الی تاريخ", 'مصارف', 'تاريخ ايجاد', 'اقدامات'];
const breadcrumbs = [{ name: 'بودجه', link: '/budgets' }]

const menuData = [
  { flag: "Edit", name: 'ايرايش', icon: 'create-outline', roles: [1, 2,20] },
  { flag: "Delete", name: 'حذف', icon: 'trash-outline', roles: [1,2,20] },
]


const searchInputFields = [
  { label: 'نام', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3' },
  { label: 'مقدار مکمل پول', name: 'amount', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3', },
  { label: 'مقدار باقی ماتده', name: 'rest_amount', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-2' },
  { label: 'از تاريخ', name: 'from_date', type: 'pdate', roles: [1], icon: 'book-outline', className: 'md:col-span-2' },
  { label: 'الی تاريخ', name: 'to_date', type: 'pdate', roles: [1], icon: 'book-outline', className: 'md:col-span-2' },
];


const newModelInputFields = [
  { label: 'نام', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'The name is requieed', isStyle: false },
  { label: 'مقدار پول', name: 'amount', type: 'number', roles: [1], icon: 'text-outline', className: '', required: 'The amount is requieed', isStyle: false },
  { label: 'از تاريخ ', name: 'from_date', type: 'pdate', roles: [1], icon: 'text-outline', className: '', required: false, isStyle: false },
  { label: 'الی تاريخ ', name: 'to_date', type: 'pdate', roles: [1], icon: 'text-outline', className: '', required: false, isStyle: false },
  { label: 'حالت', name: 'status', type: 'switch', roles: [1], icon: 'book-outline', className: '', required: false, status: true },
  { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false },

];

const csvHeaders = [
  { label: "#", key: "index" },
  { label: "نام", key: "name" },
  { label: "مقدار مکمل بول", key: "amount" },
  { label: "مقدار باقی مانده", key: "rest_amount" },
  { label: "از تاريخ", key: "from_date" },
  { label: "الی تاريخ", key: "to_date" },
  { label: "مصارف", key: "expenses" },
  { label: "تاريخ ايحاد", key: "date" },
  { label: "حالت", key: "status" },
  { label: "ايجاد کننده", key: "creator_id" },
];


export default function Budgets() {

  const {com,
    auth, setModel,
    models,navigate, 
    setShowNewModelDialog,
    setShowViewDialog,
    showDeleteDialog, setShowDeleteDialog } = useShared();


    useEffect(() => {
      if (!auth.hasRole([1,2,20])) {
          return navigate("/db/notAllowed")
      }
    }, [])
 

  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);

    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)
    }
    if (flag === 'edit') {
      setModel(model)
      setShowNewModelDialog(true)
    }
    if (flag === 'view') {
      setModel(model)
      setShowViewDialog(true)
    }
  };

  const gotoExpensesPage = (id) => {
    navigate(`/db/expenses/${id}`, { state: { budget_type_id: id } })
  }


  const handleViewDialog = (obj) => {
    return [
      { l: 'Name', v: obj?.name },
      { l: 'Type', v: obj?.parent?.label },
      { l: 'Description', v: obj?.description },
      { l: 'Added by', v: obj?.user?.full_name },
      { l: 'Status', v: obj?.status },
      { l: 'Last Update', v: com.ddmmyyhhmmA(obj?.updated_at) },
    ]
  }

  const getTableData = () => {
    const data = models?.data
    return (<><tbody className=''>
      {data?.map((r, i) => {
        return (<Fragment key={r.id}>
          {i < data?.length - 1 &&
            <tr key={r.id}>
              <td >{models?.from + i}</td>

              <td className='!p-1'> <div className='flex flex-row items-center'> <div className={` rounded-full h-3 w-3 mr-2 ${r.status === 1 || r.status ? 'bg-green-500' : 'bg-red-700'}`} /> {r.name}</div> </td>
              <td >{com.NumberFormatter(r?.amount)} ؋</td>
              <td >{com.NumberFormatter(r?.rest_amount)} ؋</td>
              <td >{r?.from_date} - {r?.to_date} </td>
              <td>{r?.expenses_count > 0 && <span className="text-blue-700 cursor-pointer" onClick={() => gotoExpensesPage(r?.id)}> ({r?.expenses_count})</span>}</td>

              <td style={{ direction: 'ltr' }}>{com.dateConvert(r?.created_at, false, true)}
                <p>{r?.user?.full_name}</p>
              </td>
              <td >
                <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />


              </td>
            </tr>}</Fragment>)
      })}
    </tbody><tfoot>
        {data?.length > 0 && <tr className='border' key={data[data?.length - 1]?.id}>
          <th className="bg-purple-500/20 text-purple-900">توتال</th>
          <th colSpan={8} className=" bg-green-400/30 text-green-900 text-lg font-bold">{com.NumberFormatter(data[data?.length - 1]?.amount)} ؋</th>
        </tr>}
      </tfoot></>)
  }

  return (
    <div>
      <MainSection v={{
        handleViewDialog,
        newModelInputFields,
        searchInputFields,
        TABLE_HEAD,
        breadcrumbs,
        tableData: getTableData(),
        modelName: { name: 'budgets', af: 'بودجه' },
        mUrl: { delete: 'budgets', create: 'budgets', getAll: 'budgetsAdvanceSearch' },
        addNewItemTitle: "بودجه جديد",
        tableTitle: 'لیست بودجه‌ها',
        newModelDialogClassName: "h-[75%]",
        csv: { csvHeaders, show: true }
      }} />
    </div>

  )

}
